import { Pipe, PipeTransform } from '@angular/core'

import {
  checkUserSessionAllowed,
  parseUserSessionsAllowed,
} from '../libs/user.lib'
import { User } from '../models/user.entity'

@Pipe({
  name: 'user',
})
export class UserPipe implements PipeTransform {
  transform(
    user: User,
    kind:
      | 'flat-name'
      | 'session-allowed'
      | 'sessions-object'
      | 'sessions-array',
    options?: {
      sessionType?: 'WEB' | 'APP'
    },
  ): string | boolean | object {
    const sessionsObj = parseUserSessionsAllowed(user)
    switch (kind) {
      case 'flat-name':
        return `${user.name} ${user.surname}`
      case 'session-allowed':
        return options?.sessionType
          ? checkUserSessionAllowed(user, options.sessionType)
          : false
      case 'sessions-object':
        return sessionsObj
      case 'sessions-array':
        return Object.keys(sessionsObj).filter(
          (key) => sessionsObj[key] === true,
        )
      default:
        return ''
    }
  }
}
